import { UserOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, Modal, Table, Tag } from 'antd';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import { useState } from 'react';
import { historyPredictions } from 'service/base';
import 'styles/global.css';

const HistoryPredictions = ({ isModalVote, setIsModalVote, IP, FP }) => {
  const { notification } = App.useApp();
  const [formHistory] = Form.useForm();
  const [account, setAccount] = useState('');
  const [dataPrediction, setDataPrediction] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 15
    }
  });
  const [pagination, setPagination] = useState({
    current: tableParams.pagination.current || 1,
    pageSize: tableParams.pagination.pageSize || 15,
    total: dataPrediction?.totalRecords || 0,
    size: 'default',
    onChange: (page, pageSize) => {
      console.log('Page change:', page, pageSize);
      setPagination({ ...pagination, current: page });
    }
  });

  const handleCancelVote = () => {
    setIsModalVote(false);
  };
  const onFinishHistoryForm = async (data) => {
    try {
      if (!account) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đang nhập!'
        });
        return;
      }
      const confirmed = window.confirm(
        'Để đảm bảo tính bảo mật, chúng tôi sẽ sử dụng những dự đoán trước đó dựa trên địa chỉ IP bạn đã truy cập để cung cấp thông tin dự đoán.'
      );
      if (!confirmed) {
        return;
      }
      data.account = account;
      setIsLoadingSubmit(true);
      data.site = SITE;
      data.ip = IP;
      data.fp = FP;
      const res = await historyPredictions(data);
      setDataPrediction(res?.data || []);
      if (!res?.data?.listPrediction[0]) {
        notification.warning({
          message: 'Không có lịch sử',
          description: 'Không tìm thấy lịch sử bình chọn, Quý khách vui lòng kiểm tra lại!'
        });
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      setIsLoadingSubmit(false);
    }
  };

  const onFinishHistoryFailed = () => {
    notification.warning({
      message: 'Cảnh báo',
      description: 'Vui lòng kiểm tra lại tài khoản !'
    });
  };

  const handleAccountChange = (event) => {
    const newAccount = event.target.value.trim();
    setAccount(newAccount.trim());
  };
  const columns = [
    {
      title: 'Trận đấu',
      render: (_, record) => {
        return record.homeName + ' - ' + record.awayName;
      }
    },
    {
      title: 'Bình chọn',
      width: '15%',
      render: (_, record) => {
        return (
          <Tag className="text-center" color="#000000" key={record._id}>
            {record.homeScore}-{record.awayScore}
          </Tag>
        );
      }
    },
    {
      title: 'Kết quả',
      width: '15%',
      render: (text, record) => {
        if (record.match_result) {
          return (
            <Tag className="text-center" color="#00890a" key={record._id}>
              {record.match_result}
            </Tag>
          );
        } else {
          return null;
        }
      }
    },
    {
      title: 'Ngày dự đoán',
      dataIndex: 'createdAt',
      render: (_, record) => dayjs(_).format('DD/MM/YYYY')
    }
  ];
  return (
    <Modal
      className="modal-jun88k36 modal-history text-[#FF0000]"
      // title="DANH SÁCH LỊCH SỬ DỰ ĐOÁN"
      title={
        <div style={{ textAlign: 'center', fontSize: '18px', color: '#FF0000' }}>
          DANH SÁCH LỊCH SỬ DỰ ĐOÁN
        </div>
      }
      open={isModalVote}
      footer={null}
      onCancel={handleCancelVote}
    >
      <div className="content-km content-history">
        <Form
          name="formHistoryMatch"
          onFinish={onFinishHistoryForm}
          onFinishFailed={onFinishHistoryFailed}
          className="relative"
          autoComplete="off"
          form={formHistory}
          initialValues={{ account: account }}
        >
          <div className="flex md:justify-center justify-between gap-2 md:py-4 py-1 w-full relative">
            <Form.Item
              name="account"
              className="mb-0 min-w-[30%] md:min-h-[38px] w-full max-w-[600px]"
            >
              <Input
                className="min-h-[38px] w-full"
                placeholder="Nhập tên đăng nhập ..."
                maxLength={30}
                value={account}
                onChange={handleAccountChange}
                prefix={<UserOutlined />}
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng điền tên đăng nhập!'
                  }
                ]}
              />
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoadingSubmit}
                className="bg-score bg-check-account text-white font-medium min-h-[32px] absolute right-3 top-[50%] translate-y-[-50%] z-30"
              >
                Xác Nhận
              </Button>
            </Form.Item>
          </div>
        </Form>
        <div className="list-history">
          <Table
            size="small"
            columns={columns}
            dataSource={dataPrediction?.responseData || []}
            loading={isLoadingSubmit}
            pagination={pagination}
          />
        </div>
      </div>
    </Modal>
  );
};

export default HistoryPredictions;
